import InputField from "../../InputField/InputField";
import { HeadingTitle } from "../ModalContainer";
import vectorUploadIcon from "../../../Assets/Icons/Vector.png";
import { toast } from "react-toastify";
import { useDropzone } from "react-dropzone";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { RxCross2 } from "react-icons/rx";
import { useSpring, animated } from "react-spring";
import axios from "axios";
import Loader from "../../Loading/Loading";
import { BASEURI } from "../../../Middleware/axiosInstance";
import secureLocalStorage from "react-secure-storage";

const InventorySyncNow = ({ title, close, currentpage, setCurrentPage }) => {
  const navigate = useNavigate();
  const baseDomain = BASEURI.split("/")[0] + "//" + BASEURI.split("/")[2];
  const token = JSON.parse(secureLocalStorage.getItem("user_UUID_MFG"))?.token;

  const [files, setFiles] = useState();
  const [filePreviews, setFilePreviews] = useState(false);
  const [showPreview, setshowPreview] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [downloadingTemplate, setDownloadingTemplate] = useState(false);

  const onDrop = useCallback((acceptedFiles) => {
    const selectedFile = acceptedFiles[0];

    if (!selectedFile) {
      toast.error("No file selected.");
      return;
    }

    if (selectedFile.type !== "text/csv") {
      toast.error("Invalid file format. Only CSV files are allowed.");
      return;
    }

    setFiles(selectedFile);
    setFilePreviews(URL.createObjectURL(selectedFile));
    setshowPreview(true);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  const previewInAnimation = useSpring({
    opacity: showPreview ? 1 : 0,
    transform: showPreview ? "scale(1)" : "scale(0)",
    config: { duration: 10 },
  });

  const handleSubmit = async () => {
    try {
      
      if(files){
        setLoading(true);
        const formData = new FormData();
        formData.append("file", files);

        const { data } = await axios.post(
          `${baseDomain}/Retails/ajaxProductImport`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (data.status === 1) {
          axios.post(`${BASEURI}`, {
            service_name: "run_cron_jobs",
            token: token,
            cron: "portal_net_available_inventory_data",
            product_ids: data.accepted.toString(),
          })
          .then((result) => {
            setLoading(false);
            setCurrentPage(1)
            toast.success('All SKUs have been imported successfully. Sync will now begin for the imported SKUs.');
            setshowPreview(false);
            close();
            setTimeout(() => {
              window.location.href = window.location.origin + '/portal-net-inventory-summary';
            }, 3000);
          })
          .catch(() => {
            setLoading(false);
          })
        } else {
          toast.error(data?.msg);
          setLoading(false);
        }
      } else {
        axios.post(`${BASEURI}`, {
          service_name: "run_cron_jobs",
          token: token,
          cron: "portal_net_available_inventory_data",
        })
        .then((result) => {
          setLoading(false);
          toast.success('All SKUs have been imported successfully. Sync will now begin for the imported SKUs.');
          close();
          setTimeout(() => {
            window.location.href = window.location.origin + '/portal-net-inventory-summary';
          }, 3000);
        })
        .catch(() => {
          setLoading(false);
        })
      }
      
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const handleDownloadSampleFile = async () => {
    try {
      setDownloadingTemplate(true);
      const response = await axios.get(`${baseDomain}/Retails/ajaxProductImport`);

      if (response.data.status === 1 && response.data.sample) {
        // Construct full URL with baseDomain + sample path
        const fileUrl = `${baseDomain}/${response.data.sample}`;
        
        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = 'inventory_sync_sample.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        toast.success("Sample file downloaded successfully!");
      } else {
        toast.error(response.data.msg || "Download failed");
      }
      setDownloadingTemplate(false);
    } catch (error) {
      setDownloadingTemplate(false);
      toast.error("Error downloading sample file");
      console.error(error);
    }
  };

  return (
    <div>
      <HeadingTitle title={title} center={false} closeModal={close} />
      
      {!uploadedFile ? (
        <>
          <div className="mt-3 text-center">
            <div className="browse-files" {...getRootProps()}>
              <input {...getInputProps()} />
              {isDragActive ? (
                <>
                  <img src={vectorUploadIcon} alt="" />
                  <h2 className="upload-tag">{ files ? 'File Uploaded' : 'Import File' }</h2>
                  <p className="drag-tag">
                    Drag and Drop file here Or <span>Choose file</span>
                  </p>
                  <p className="drag-small-tag">
                    Support formats: CSV | Minimum size: 5 MB
                  </p>
                </>
              ) : (
                <>
                  <img src={vectorUploadIcon} alt="" />
                  <h2 className="upload-tag">{ files ? 'File Uploaded' : 'Import File' }</h2>
                  <p className="drag-tag">
                    Drag and Drop file here Or <span>Choose file</span>
                  </p>
                  <p className="drag-small-tag">
                    Support formats: CSV | Minimum size: 5 MB
                  </p>
                </>
              )}
            </div>
          </div>

          {/* {showPreview && files && (
            <div style={{
              marginTop: '20px',
              padding: '15px',
              backgroundColor: '#f0f8ff',
              borderRadius: '8px',
              border: '1px solid #3C94C6'
            }}>
              <h3 style={{ color: '#3C94C6', marginBottom: '10px' }}>📄 File Selected</h3>
              <p><strong>File Name:</strong> {files.name}</p>
              <p><strong>File Size:</strong> {(files.size / 1024).toFixed(2)} KB</p>
              <p><strong>File Type:</strong> {files.type}</p>
            </div>
          )} */}

          <div style={{ padding: '10px 25px', fontFamily: "Poppins_SemiBold" }}>
            <b>
              <p><span style={{ color: 'red' }}>Note: </span> If no SKUs are imported, all SKUs will be considered for the sync.</p>
            </b>
          </div>

          <div style={{ marginTop: '20px', textAlign: 'center', marginBottom: '10px', display: 'flex', gap: '10px', justifyContent: 'center', alignItems: 'center' }}>
            <button
              onClick={handleDownloadSampleFile}
              disabled={downloadingTemplate}
              style={{
                padding: '10px 20px',
                backgroundColor: '#f0f0f0',
                border: '1px solid #ccc',
                borderRadius: '8px',
                cursor: downloadingTemplate ? 'not-allowed' : 'pointer',
                fontSize: '14px'
              }}
            >
              {downloadingTemplate ? 'Downloading...' : '📥 Download Sample File'}
            </button>

            <button
              className=""
              onClick={handleSubmit}
              // disabled={!files}
              style={{ 
                padding: '12px 20px',
                backgroundColor: files ? "#3C94C6" : "#3C94C6",
                cursor: "pointer",
                borderRadius: '15px',
                border: 'none',
                fontWeight: 'bold',
                color: 'white',
                fontSize: '14px'
              }}
            >
              {loading ? <Loader color={"#ffffff"} size={18} /> : "Submit"}
            </button>
          </div>

          <style>
          {`
            .add-btn {
              border-radius: 15px !important;
            }
          `}
          </style>
        </>
      ) : (
        <div style={{
          marginTop: '30px',
          padding: '25px',
          backgroundColor: '#f0fff4',
          borderRadius: '8px',
          border: '2px solid #10b981',
          textAlign: 'center'
        }}>
          <h3 style={{ color: '#10b981', marginBottom: '15px', fontSize: '18px' }}>✓ File Uploaded Successfully</h3>
          <p><strong>File Name:</strong> {uploadedFile.name}</p>
          <p><strong>File Size:</strong> {(uploadedFile.size / 1024).toFixed(2)} KB</p>
          <p><strong>Uploaded At:</strong> {uploadedFile.uploadedAt}</p>
        </div>
      )}
    </div>
  );
};

export default InventorySyncNow;
